// =============================================================================
// PasswordReset.js  (A5 – "Passwort vergessen" anfordern)
// -----------------------------------------------------------------------------
// Fordert einen "Passwort festlegen"-Einmal-Link per E-Mail an. Die Antwort ist
// bewusst generisch (keine Preisgabe, ob ein Konto existiert).
// Gesteuert ueber Feature-Flag FEATURES.passwordReset.
// =============================================================================

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Form } from "react-bootstrap";
import UserService from "../services/user.service";
import FEATURES from "../config/features";

const PasswordReset = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!FEATURES.passwordReset) {
    return (
      <div className="container myn-signup">
        <h1 className="myn-signup__title">Passwort vergessen</h1>
        <Alert variant="warning">Diese Funktion ist derzeit nicht verfügbar.</Alert>
        <Button as={Link} to="/login">Zur Anmeldung</Button>
      </div>
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setLoading(true);
    try {
      const response = await UserService.requestPasswordReset(email.trim());
      setSent(true);
      setMessage(
        (response.data && response.data.message) ||
          "Wenn ein Konto zu dieser E-Mail-Adresse existiert, wurde ein Link gesendet."
      );
    } catch (error) {
      // Auch bei Fehlern generisch antworten (keine Enumeration).
      setSent(true);
      setMessage(
        "Wenn ein Konto zu dieser E-Mail-Adresse existiert, wurde ein Link gesendet."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container myn-signup">
      <h1 className="myn-signup__title">Passwort vergessen</h1>
      {message && <Alert variant={sent ? "success" : "warning"}>{message}</Alert>}
      {!sent && (
        <Form onSubmit={handleSubmit} className="mt-3">
          <Form.Group controlId="resetEmail">
            <Form.Label>E-Mail-Adresse</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
              placeholder="ihre@email.de"
            />
          </Form.Group>
          <Button type="submit" className="mt-3" disabled={loading}>
            {loading ? "Wird gesendet …" : "Link anfordern"}
          </Button>
        </Form>
      )}
      <div className="mt-4">
        <Button as={Link} to="/login" variant="link">Zurück zur Anmeldung</Button>
      </div>
    </div>
  );
};

export default PasswordReset;
